<template>
 <ElButton
    data-bs-toggle="modal"
    :data-bs-target="`#${props.modalId}`"
    ref="openModalBtnRef"
    v-show="false"
  />

  <!-- 
    props.modalId : 다른 모달 id와 안겹쳐야합니다.
    props.modalNm : 모달 이름
    props.size : 모달 사이즈 => sm : 작은사이즈(300px) , 값 x : default(500px) , lg : 큰사이즈(800px) , xl : 젤 큰 사이즈(1140px) 
    props.btnList : [{name : '버튼1' , class : 'btn btn-secondary btn-sm' , function : testFun()}]
  -->
<div class="modal fade" :id="`${props.modalId}`" tabindex="-1" aria-hidden="true">
    <div :class="`modal-dialog modal-${props.size} modal-dialog-centered modal-dialog-scrollable`">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-6">{{ props.modalNm ? props.modalNm : 'Modal' }}</h1>
                <ElButton type="modelHeaderClose"
                ></ElButton>
            </div>

            <div class="modal-body">
                <slot name="body"></slot>
            </div>

            <div class="modal-footer">
                <ElButton
                    v-for="btn in props.btnList"
                    :type="btn.classNm"
                    @buttonClick="btn.function"
                >
                    {{ btn.name }}
                </ElButton>

                <ElButton
                    type="modelFooterClose"
                    slot="footer"
                    data-bs-dismiss="modal"
                    ref="closeModalBtn"
                >
                    닫기
                </ElButton>
            </div>
        </div>
    </div>
</div>
</template>
<script setup>
import { ref } from 'vue'

const openModalBtnRef = ref()
const closeModalBtn = ref()
const props = defineProps(['modalNm','btnList','size','modalId'])



function openModal() {
    openModalBtnRef.value.button.click()
}

function closeModal(){
    closeModalBtn.value.button.click()
}

defineExpose({
    openModal,
    closeModal
})
</script>

